<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">收货地址 <span class="editBtn" @click="addShow" v-show="listData.length < 3">新增</span></div>
          <!-- <div class="subTitle"><span></span>会员信息</div> -->
          <div class="userInfoBox" v-if="addBoxFlag">
            <el-form ref="form" :model="objData" :rules="rules" label-width="161px">
              <el-form-item label="收货人姓名" prop="name">
                <el-input v-model="objData.name" placeholder="请输入收货人姓名" :maxlength="10"></el-input>
              </el-form-item>
              <!-- <el-form-item label="身份证" prop="idNumber">
                <el-input v-model="formData.idNumber" placeholder="请输入身份证" :disabled="true"></el-input>
              </el-form-item> -->
              <el-form-item label="手机号码" prop="phone">
                <el-input type="number" v-model="objData.phone" placeholder="请输入手机号码" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
              </el-form-item>
              <el-form-item label="地址信息" prop="areaCode">
                <el-cascader
                    v-model="areaCode"
                    :options="areaOption"
                    clearable
                    @change="handleChange">
                </el-cascader>
                <input type="hidden" v-model="objData.areaCode" name="">
              </el-form-item>
              <el-form-item label="详细地址" prop="address">
                <el-input
                  type="textarea"
                  :maxlength="50"
                  :rows="2"
                  placeholder="请输入详细地址"
                  v-model="objData.address">
                </el-input>
              </el-form-item>
              <el-form-item label="">
                <p class="defaultAddress"><label @click="setDefault"><i :class="{'active':objData.isDefault == 1}"></i><span>设置为默认收货地址</span></label></p>
                <div class="addBtn">
                  <span @click="addSave" class="save">保存</span>
                  <span @click="closeAdd">取消</span>
                </div>
                <p class="addTip">注：收货地址最多只能保存3条</p>
              </el-form-item>
            </el-form>
          </div>
          <div class="addressList" v-if="!addBoxFlag">
            <div class="addTh">
              <el-row>
                <el-col :span="3">收货人</el-col>
                <el-col :span="6">所在地区</el-col>
                <el-col :span="5">详细地址</el-col>
                <el-col :span="4">电话/手机</el-col>
                <el-col :span="3">操作</el-col>
                <el-col :span="3">默认</el-col>
              </el-row>
            </div>
            <div class="addTd" v-for="(item,index) in listData" :key="index">
              <el-row>
                <el-col :span="3">{{item.name}}</el-col>
                <el-col :span="6">{{item.areaName}}</el-col>
                <el-col :span="5">{{item.address}}</el-col>
                <el-col :span="4">{{item.phone}}</el-col>
                <el-col :span="3"><span class="eidt" @click="update(item)">修改</span>|<span class="delete" @click="deleteAddress(item.id)">删除</span></el-col>
                <el-col :span="3">
                  <span class="default" v-if="item.isDefault == 1">默认地址</span>
                  <span class="setDefault" v-if="item.isDefault == 2" @click="setDefaultFn(item.id)">设为默认</span>
                </el-col>
              </el-row>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  import areaCode from "@/utils/areaCode"
  export default {
    components: {
      LeftSide
    },
    data(){
      return {
        orderId:'',
        areaCode:[],
        //memberId:9,
        editId:'',
        addBoxFlag:false,
        objData:{
          name:'',
          phone:'',
          areaCode:'',
          areaName:'',
          address:'',
          isDefault:2,
        },
        listData:[],
        rules:{
          name:[{required: true, trigger: 'blur',message:'请输入收货人姓名'}],
          phone:[{required: true, trigger: 'blur',message:'请输入手机号码'}],
          areaCode:[{required: true, trigger: 'change',message:'请选择地址'}],
          address:[{required: true, trigger: 'blur',message:'请输入详细地址'}],
        },
        evaluateStr:'',
        areaOption:areaCode.areavalue
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.getAddressList()
          }
        },
        immediate: true
      }
    },
    created(){
      //this.orderId = this.$route.params.id
      //this.getOrderObj()
      //this.getAddressList()
    },
    mounted(){
      eventVue.$emit("leftSwitch",'6')
    },
    methods:{
      // statusChange(sta){
      //   this.status = sta
      //   this.curPage = 1
      //   this.getOrderList()
      // },
      getAddressList(){
        //this.listData=[]
        this.$https.get('/api/address/memberId/'+this.userData.id).then((response)=>{
          this.listData = response.data
        });
      },
      deleteAddress(id){
        this.$confirm('是否删除该地址？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$https.post('/api/address/id/'+id,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              this.getAddressList()
            }else{
              this.$message.warning(res.message)
            }
          });
        }).catch(() => {});
      },
      addSave(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.objData.memberId = this.userData.id
            if(!this.editId){
              this.$https.post('/api/address/addAddress',this.objData).then(res => {
                if(res.code == 0){
                  this.$message.success("操作成功")
                  this.closeAdd()
                  this.getAddressList()
                }else{
                  this.$message.warning(res.msg)
                }
              });
            }else{
              this.objData.id = this.editId
              this.$https.post('/api/address/updateAddress',this.objData).then(res => {
                if(res.code == 0){
                  this.$message.success("操作成功")
                  this.closeAdd()
                  this.getAddressList()
                }else{
                  this.$message.warning(res.message)
                }
              });
            }
          }
        })
      },
      update(obj){
        this.editId = obj.id
        let tempArr = obj.areaCode.split(',')
        this.areaCode = [parseInt(tempArr[0]),parseInt(tempArr[1]),parseInt(tempArr[2])]
        //this.objData = obj

        this.objData.name = obj.name
        this.objData.phone = obj.phone
        this.objData.areaCode = obj.areaCode
        this.objData.areaName = obj.areaName
        this.objData.address = obj.address
        this.objData.isDefault = obj.isDefault
        
        this.addBoxFlag = true
      },
      setDefaultFn(id){
        this.$https.post('/api/address/updateDefaultAddress/id/'+id).then((response)=>{
          if(response.code == 0){
            this.$message.success("操作成功")
            this.getAddressList()
          }else{
            this.$message.warning(res.message)
          }
        });
      },
      addShow(){
        this.addBoxFlag = true
      },
      closeAdd(){
        this.$refs.form.resetFields()
        this.editId = ""
        this.areaCode = []
        this.objData.name = ''
        this.objData.phone = ''
        this.objData.areaCode = ''
        this.objData.areaName = ''
        this.objData.address = ''
        this.objData.isDefault = 2
        this.addBoxFlag = false
      },
      handleCurrentChange(val){
        this.curPage = val
        this.getOrderList()
      },
      handleChange(val){
        if(val && val[2]){
          this.objData.areaCode = val.join(',')
          this.objData.areaName = areaCode.getCompleteAddress(val[2])
        }else{
          this.objData.areaCode = ''
          this.objData.areaName = ''
          this.areaCode = []
        }
      },
      /*设为默认*/
      setDefault(){
        if(this.objData.isDefault == 1){
          this.objData.isDefault = 0
        }else{
          this.objData.isDefault = 1
        }
      }
    }
  }
</script>

<style scoped>
  .userInfoBox{
    width: 454px;
    padding-top: 24px;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .subTitle{
    padding: 10px 0 0 15px;
    height: 52px;
    line-height: 52px;
    font-size: 18px;
    color: #333333;
  }
  .subTitle span{
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #5680F9;
    border-radius: 50%;
    margin-right: 15px;
  }
  .defaultAddress{
    line-height: 32px;
  }
  .defaultAddress i{
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid #5680F9;
    border-radius: 50%;
    position: relative;
    top: 4px;
    cursor: pointer;
  }
  .defaultAddress i.active:after{
    content: " ";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background: #5680F9;
    border-radius: 50%;
  }
  .defaultAddress span{
    display: inline-block;
    position: relative;
    margin-left: 5px;
    cursor: pointer;
    color: #919191;
    font-size: 12px;
  }
  .addBtn{
    margin-top: 15px;
  }
  .addBtn span{
    display: inline-block;
    line-height: 38px;
    text-align: center;
    width: 96px;
    height: 38px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    cursor: pointer;
    color: #919191;
  }
  .addBtn span.save{
    border: 1px solid #FFCD30;
    background: #FFCD30;
    color: #ffffff;
    margin-right: 20px;
  }
  .addTip{
    line-height: 57px;
    color: #919191;
    font-size: 12px;
  }
  .addressList{
    width: 818px;
    padding-top: 30px;
    padding-left: 20px;
  }
  .addressList .addTh{
    height: 40px;
    line-height: 40px;
    background: #5680F9;
    border-radius: 4px 4px 0px 0px;
    text-align: center;
    color: #ffffff;
  }
  .addressList .addTd{
    line-height: 16px;
    padding: 7px 0;
    text-align: center;
    color: #ffffff;
    color: #919191;
    min-height: 60px;
    font-size: 12px;
    border: 1px solid #E5E5E5;
  }
  .addressList .eidt{color: #5680F9;cursor: pointer;}
  .addressList .delete{color: #5680F9;cursor: pointer;}
  .addressList .default{color: #E50001;}
  .addressList .setDefault{color: #5680F9;cursor: pointer;}
  .addressList .addTd+.addTd{
    margin-top: -1px;
  }

</style>



// WEBPACK FOOTER //
// src/components/address.vue